import { createFileRoute } from "@tanstack/react-router"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { CliPage } from "./-components/CliPage"

export const Route = createFileRoute("/features/cli/")({
  head: () =>
    seoMeta({
      title: "Entire CLI",
      description: marketingPages["/features/cli"].description,
      url: "https://entire.com/features/cli",
      image: "/images/og/cli.png",
      imageAlt: "Entire CLI",
    }),
  component: CliPage,
})
